import { FluxStandardAction as Action } from "flux-standard-action";
import { COLLECTIONS } from "constants/action-types";
import { IPackInfo } from "reducers/collection";
import { ISizePacksTolerance } from "constants/product-collection";

export const fetchSizePacks = (brand: string, includeNormalized = true, lastFetchedId?: string) => {
    return {
        payload: {
            brand,
            includeNormalized,
            lastFetchedId,
        },
        type: COLLECTIONS.COLLECTION.SIZE_PACKS.FETCH.START,
    };
};

export const sizePacksFetchComplete = (
    newSizePacks?: { [key: string]: { [key1: string]: IPackInfo } },
    error: boolean = false
) => {
    return {
        payload: {
            newSizePacks,
            error,
        },
        type: COLLECTIONS.COLLECTION.SIZE_PACKS.FETCH.COMPLETED,
    };
};

interface IUpdateCollectionSizePacksTolerancePayload {
    collectionId: string;
    sizePacksTolerance: ISizePacksTolerance | null;
}
export type IUpdateCollectionSizePacksToleranceAction = Action<IUpdateCollectionSizePacksTolerancePayload, {}>;
export const updateCollectionSizePacksTolerance = (
    payload: IUpdateCollectionSizePacksTolerancePayload
): IUpdateCollectionSizePacksToleranceAction => {
    return {
        meta: {},
        payload,
        type: COLLECTIONS.COLLECTION.SIZE_PACKS.SET_TOLERANCE.START,
    };
};
